module.exports = "/virtual-football-league/img/amblems/left/Italy/Fake_Lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Italy/Fake_Lazio.png
// module id = 2041
// module chunks = 4